import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  AgentResponseSchema,
  AISpecificHeadersSchema,
  AiApiSpec_AddToGenerateNoteQueueCallbackBodySchema,
  CreateTimeIntervalPredictionsSchema,
  CreateTrainingSummarySchema,
  OKGeneric,
} from '../../models';

extendZodWithOpenApi(z);
const c = initContract();

export const apiAiEngineRoute = c.router({
  /**
   * AI endpoint for writing time interval predictions
   * @warning Inherited as schema on AI OpenAPI spec, MUST BE KEPT IN SYNC IF CHANGED
   */
  createTimeIntervalPredictions: {
    method: 'POST',
    path: `/1.0/predictions/time-intervals`,
    summary: 'Make time interval predictions',
    description:
      'Intervals should be rounded to "full minutes" and avoid overlapping (but neither is enforced atm). \n\n Predictions can be made spanning multiple days. \n\nAny previous predictions that co-exists/overlaps with the incoming time range will be deleted. (as in, between first intervals `started_at` and last intervals `ended_at`)\n\n**Dispatches Pusher** event `newPredictions` to channel `private-{timelyUserId}`',
    body: CreateTimeIntervalPredictionsSchema.openapi({
      description:
        'If range is not supplied, it will be inferred from the `intervals`. Any prior predictions in the range will be removed automatically.\n\nThe `last_predicted_at` will be stored as `NOW()` for _each day_ in the range_started/ended_at`.',
    }),
    responses: {
      200: OKGeneric,
    },
    headers: AISpecificHeadersSchema,
  },
  /**
   * AI endpoint for sending training summaries
   * @warning Inherited as schema on AI OpenAPI spec, MUST BE KEPT IN SYNC IF CHANGED
   */
  createTrainingSummary: {
    method: 'POST',
    path: `/1.0/predictions/training-summary`,
    summary: 'Summary of of AI model training',
    description:
      'Receives and stores a summary report from the AI model training process. Contains metrics about the training run including data points processed, model performance indicators, and training status. Used by the AI engine to report back training results.',
    body: CreateTrainingSummarySchema,
    responses: {
      200: OKGeneric,
    },
  },
  createAgentResponse: {
    method: 'POST',
    path: `/1.0/predictions/agent-response`,
    summary: 'Webhook for agent response',
    description:
      'Webhook for agent response. Payload will contain response_type (intervals/text), inferred_dates and intervals/timestamps with attached predictions',
    body: AgentResponseSchema,
    responses: {
      200: OKGeneric,
    },
    headers: AISpecificHeadersSchema,
  },

  // New webhook for note generation completion
  updatedGeneratedNote: {
    method: 'POST',
    path: `/1.0/ai/webhooks/note_generated`,
    summary: 'Webhook for completed note generation',
    description: 'Received when async note generation completes',
    body: AiApiSpec_AddToGenerateNoteQueueCallbackBodySchema,
    responses: {
      200: OKGeneric,
    },
    headers: AISpecificHeadersSchema,
  },
});
